export default __webpack_public_path__ + "static/7-cb46149c77ac5ba5d5e69656d85a9c9b.png";